import { useLocation, Navigate } from "react-router-dom"
import useAuth from "./useAuth"

const RequireAuthCompany = ({children}) => {
    const {token, setToken, typeUser} = useAuth()
    let location = useLocation()

    if(!token){
        return <Navigate to="/" state={{ from: location }} replace />;
    }else{
        if(token !== "undefined" && typeUser === "Company"){
            return children
        }else{
            setToken(null)
            localStorage.removeItem('tokomarket_token')
            localStorage.removeItem('tokomarket_type_user')
            return <Navigate to="/" state={{ from: location }} replace />
        }
    }
}

export default RequireAuthCompany